import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row gx-0" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex position-relative w-100 h-100 align-items-center justify-content-start",
  style: {"background-color":"rgba(255, 255, 255, 0.5)"}
}
const _hoisted_3 = { class: "d-block w-100 text-center px-5 py-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-success",
  role: "status"
}, null, -1)
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = { class: "col-12 px-5 py-3 border-bottom border-primary" }
const _hoisted_7 = { class: "fw-bold text-uppercase mb-0 h5" }
const _hoisted_8 = {
  key: 0,
  class: "col-12 px-5 py-3 bg-danger text-white"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", null, "Ocurrió un error al traer los turnos disponibles", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "col-12 px-5 py-3 bg-dark text-white"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h5", null, "No se encuentran turnos disponibles", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "col-12 px-5 py-3"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Elegí un día", -1)
const _hoisted_16 = ["value"]

import { ref, onMounted, watch } from 'vue'
import DaysComposable from '@/composables/Days'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormDate',
  props: {
    actividadId: null,
    tipoActividad: null,
    modelValue: null,
    conAccesoVip: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  actividadId: number
  tipoActividad: string
  modelValue: object
  conAccesoVip: boolean
};





const { days, loading, error, fetchDay } = DaysComposable()
// const { commit } = useStore(key)
const dayValue = ref()
// const { t } = useI18n()
// const { getters } = useStore<VuexStore>(key)

const onChange = (event: any) => {
  const data = days.value.find(
    (element) =>
      parseInt(element.id.toString()) === parseInt(event.target?.value)
  )
  if (data?.id) {
    // commit('CLEAR_TURNO_SOLO')
    emit('update:modelValue', data)
  }
}

onMounted(async () => {
  emit('update:modelValue', {})
  dayValue.value = null
  await fetchDay(props.actividadId, props.conAccesoVip)
})

watch(
  () => props.conAccesoVip,
  async () => {
    emit('update:modelValue', {})
    dayValue.value = null

    await fetchDay(props.actividadId, props.conAccesoVip)
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(loading).status)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h6", _hoisted_5, _toDisplayString(_unref(loading).text), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h5", _hoisted_7, [
              (
              __props.conAccesoVip === undefined || props.tipoActividad !== 'recital'
            )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Elegí un día y horario ")
                  ], 64))
                : (__props.conAccesoVip === true)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Elegí un día y horario | VIP exclusivo ")
                    ], 64))
                  : (__props.conAccesoVip === false)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(" Elegí un día y horario | Campo general ")
                      ], 64))
                    : _createCommentVNode("", true)
            ])
          ]),
          (_unref(error))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (!_unref(days).length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("select", {
                        class: "input",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dayValue).value = $event)),
                        onChange: onChange
                      }, [
                        _hoisted_15,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(days), (day) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: day.id,
                            value: day.id
                          }, _toDisplayString(day.concatenado), 9, _hoisted_16))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, dayValue.value]
                      ])
                    ]))
              ], 64))
        ], 64))
  ]))
}
}

})